import {useEffect, useState} from 'react';
import {useFetchGetData, useFetchPostData} from './useFetchData'
import {useQueryParams} from './useLocationData'
import recipesMapping from '../data/mapping/pages/recipesMapping';
import promotionsPageMapping from '../data/mapping/pages/promotionsPageMapping';
import promotionsMockData from '../data/recipes.json';

const usePromotionsData = (pageNumber) => {
  const pageType = 'promotions'
  const queryKey = 'promotionsData' + pageNumber;
  let promotionsQueryPath = '/jsonapi/views/promotion_list_component/promotion_list_component?page=' + pageNumber;

  const queryParams = useQueryParams();
  const isMockData = queryParams.get('useMockData') === 'true';
  const [promotionsQueryData, setPromotionsQueryData] = useState('');
  const { isLoading, error, data } = useFetchGetData(queryKey, promotionsQueryPath, isMockData);

  useEffect(() => {
    if (data && !isMockData) {
      const mappedData = recipesMapping(data, pageType);
      setPromotionsQueryData(mappedData);
    }
  }, [data, isMockData])

  if (isMockData) {
    return {
      error: false,
      isLoading: false,
      promotionsQueryData: promotionsMockData
    };
  }

  return  {
    error,
    isLoading,
    promotionsQueryData
  };
}

const usePromotionsPageData = (pagePath) => {
  const queryKey = 'promotionsData' + pagePath;
  const queryParams = useQueryParams();
  const isMockData = queryParams.get('useMockData') === 'true';
  const [promotionsPageQueryData, setPromotionsPageQueryData] = useState('');
  const { promotionsIsLoading, promotionsError, data } = useFetchPostData(queryKey, pagePath, isMockData);

  useEffect(() => {
    if (data && !isMockData) {
      const mappedData = promotionsPageMapping(data);
      setPromotionsPageQueryData(mappedData);
    }
  }, [data, isMockData])

  if (isMockData) {
    return {
      promotionsError: false,
      promotionsIsLoading: false,
      promotionsPageQueryData: promotionsMockData
    };
  }

  return  {
    promotionsError,
    promotionsIsLoading,
    promotionsPageQueryData
  };
}

export  { usePromotionsPageData, usePromotionsData };
